import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIRichTextEditor from "mui-rte";
import React, { useState, useEffect } from "react";
import { EditorState, convertToRaw } from "draft-js";

const TextEditor = ({ handleChangeText, type, value, maxLength, name, id, register }) => {
  const [text, setText] = useState(value ? JSON.stringify(value) : "");

  useEffect(() => {
    setText(value ? JSON.stringify(value) : "");
  }, [value]);

  const change = (event) => {
    const plainText = event.getCurrentContent().getPlainText(); // for plain text

    const rteContent = convertToRaw(event.getCurrentContent()); // for rte content with text formating
    handleChangeText(rteContent, type);
  };
  const myTheme = createTheme({
    overrides: {
      MUIRichTextEditor: {
        root: {
          marginTop: 20,
          width: "100%",
          marginBottom: 20,
          border: "1px solid lightGrey",
        },
        editor: {
          borderTop: "1px solid lightGrey",
          padding: 10,
          height: 100,
          maxHeight: 100,
          overflow: "auto",
        },
      },
    },
  });
  return (
    <div>
      <ThemeProvider theme={myTheme}>
        <MUIRichTextEditor
          label="Type Text..."
          id="text"
          name="text"
          controls={
            type === "question" && name !== "content"
              ? ["bold", "italic", "underline", "strikethrough", "undo", "redo"]
              : [
                  "bold",
                  "italic",
                  "underline",
                  "link",
                  "strikethrough",
                  "undo",
                  "redo",
                ]
          }
          //inlineToolbar={true}
          onChange={change}
          value={text}
          maxLength={maxLength ? maxLength : 200}
        />
      </ThemeProvider>
    </div>
  );
};

export default TextEditor;
